import './devLogger';
import React from 'react';
import ReactDOM from 'react-dom/client';
// @ts-expect-error react-modal ships no type declarations
import ReactModal from 'react-modal';
import './index.scss';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './store';
import reportWebVitals from './reportWebVitals';
import { purgeCredentials } from './helpers/utils/auth-payload';

// Scrubs credential keys older builds left in localStorage, before the app mounts.
purgeCredentials();

// Set react-modal's app element once at startup so no modal logs the
// "App element is not defined" warning (which floods the console when several are mounted).
ReactModal.setAppElement('#root');

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <App />
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
);

reportWebVitals();
